const {
    REACT_APP_API_URL,
    REACT_APP_BACKEND_URL,
    REACT_APP_URL_EXTENSION,
    REACT_APP_ENV,
    REACT_APP_PUSHER_KEY,
    REACT_APP_STRIPE_PUBLIC_KEY,
    REACT_APP_TINYMCE_API_KEY,
} = process.env

const config = {
    apiUrl: REACT_APP_API_URL,
    backendUrl: REACT_APP_BACKEND_URL,
    appUrlExtension: REACT_APP_URL_EXTENSION,
    env: REACT_APP_ENV,
    pusherKey: REACT_APP_PUSHER_KEY,
    stripeKey: REACT_APP_STRIPE_PUBLIC_KEY,
    tinymceKey: REACT_APP_TINYMCE_API_KEY,
}

export default config
